import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

/**
 * Global service to log messages to the console
 */
export class LoggerService {

  private static readonly PREFIX = '[LoggerService]';
  private static readonly INFO_PREFIX = LoggerService.PREFIX + '[INFO]';
  private static readonly ERROR_PREFIX = LoggerService.PREFIX + '[ERROR]';
  private static readonly WARN_PREFIX = LoggerService.PREFIX + '[WARN]';
  private static readonly DEBUG_PREFIX = LoggerService.PREFIX + '[DEBUG]';


private  level = LogLevel.DEBUG; // Default level
constructor() {

  this.level = environment.debuglevel;
}

debug(message: any) {
  if (this.level <= LogLevel.DEBUG) {
    console.log(LoggerService.DEBUG_PREFIX +  new Date().toISOString() + message);
  }
}

info(message: any) {
  if (this.level <= LogLevel.INFO) {
    console.log(LoggerService.INFO_PREFIX +  new Date().toISOString() + message);
  }
}
warn(message: any) {
  if (this.level <= LogLevel.WARN) {
       console.warn(LoggerService.WARN_PREFIX +  new Date().toISOString() + message);
  }
}

error(message: any) {
  if (this.level <= LogLevel.ERROR) {
    console.error(LoggerService.ERROR_PREFIX +  new Date().toISOString() + message);
  }
}
}


//ENUM FOR LOG LEVELS
 export enum LogLevel {
  DEBUG= 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3

}


